module.exports = __webpack_public_path__ + "static/media/hariadi-2.25f7cdd7.jpg";